import React from "react";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-[76px] leading-[0.95] text-[#1A1A1A]"
          >
            We're Three Balls.{" "}
            <span className="text-[#E9298A]">Nice to&nbsp;meet&nbsp;you.</span>
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: 0.2 }}
            className="mt-8 tb-sticker wobble"
          >
            HK-based · World-ready
          </motion.div>
        </div>

        <div className="lg:col-span-7 lg:pt-10">
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="space-y-5 text-lg md:text-xl leading-[1.5] text-[#1A1A1A]"
          >
            <p>
              We're a Hong Kong-based team with a global outlook. We create modern,
              high-performing websites for businesses everywhere — from local Hong Kong
              SMEs and ambitious startups to companies needing more complex web
              applications.
            </p>
            <p>
              Whether you want a one-time custom build or our hassle-free{" "}
              <span className="font-semibold">Website as a Service</span> (we build it,
              host it, maintain it, update it — you just enjoy the results), we've got
              you covered.
            </p>
            <p className="text-[#1A1A1A]/80">
              Think of us as your friendly, reliable web partner — no matter where you
              are.
            </p>
          </motion.div>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {[
              { k: "Sites shipped", v: "40+" },
              { k: "Avg. response", v: "< 24h" },
              { k: "Clients", v: "Everywhere" },
            ].map((s) => (
              <motion.div
                key={s.k}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.6 }}
                className="border border-[#1A1A1A] rounded-2xl p-5 md:p-6 bg-white"
              >
                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#1A1A1A]/60">
                  {s.k}
                </div>
                <div className="mt-2 font-display font-black text-2xl md:text-3xl tracking-tight text-[#1A1A1A]">
                  {s.v}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
